import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  public horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  public verticalPosition: MatSnackBarVerticalPosition = 'top';
  public durationInSeconds = 5;
  constructor(private snackbar: MatSnackBar) {}

  // tslint:disable-next-line: deprecation
  success(component: any, message: string, title: string, duration?: any): void {
    this.snackbar.openFromComponent(component, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: duration ? duration * 1000 : this.durationInSeconds * 1000,
      data: { message, title },
      panelClass: ['success'],
    });
  }
  clear(): void {
    this.snackbar.dismiss();
  }
  info(component: any, message: string, title: string): void {
    this.snackbar.openFromComponent(component, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: this.durationInSeconds * 1000,
      data: { message, title },
      panelClass: ['info'],
    });
  }

  // tslint:disable-next-line: deprecation
  warning(component: any, message: string, title: string): void {
    this.snackbar.openFromComponent(component, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: this.durationInSeconds * 1000,
      data: { message, title },
      panelClass: ['warn'],
    });
  }

  // tslint:disable-next-line: deprecation
  error(component: any, message: string, title: string): void {
    this.snackbar.openFromComponent(component, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: this.durationInSeconds * 1000,
      data: { message, title },
      panelClass: ['error'],
    });
  }
}
